import { RemoteGetAllActivitiesByStatus } from 'data/usecases/dashboard';
import { GetAllActivitiesByStatus } from 'domain/usecases/dashboard';
import { makeApiUrlAllActivitiesByStatus } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByStatus = (): GetAllActivitiesByStatus =>
  new RemoteGetAllActivitiesByStatus(
    makeApiUrlAllActivitiesByStatus(),
    makeAxiosHttpClient(),
  );
